import { createConsumer } from '@rails/actioncable'
import { parsePostsHTML, removeDuplicates } from '~/frontend/util.js'
import { hideBlockedPosts, ensureFilterButtons, isPostBlocked } from '~/frontend/filter.js'

let unreadPosts = 0;

const receivedCallback = (message) => {
  if (message.event === 'changed') postUpdated(message);
  else if (message.event === 'created') postCreated(message);
  else if (message.event === 'stats_updated') statsUpdated(message);
};

const statsUpdated = (post) => {
  document.querySelector('body > #Content > #_stats').innerHTML = post.html_fragment;
};

const postUpdated = (post) => {
  const a = document.querySelector(`body > #Content > table > tbody > tr > td:first-child > a:first-child[href="${post.url}"]`);
  if (!a) return;

  const postNode = parsePostsHTML(post.html_fragment)[0];

  a.parentElement.parentElement.replaceWith(postNode);

  hideBlockedPosts();
  ensureFilterButtons();
};

const postCreated = (post) => {
  const tbody = document.querySelector('body > #Content > table > tbody');
  const postNode = parsePostsHTML(post.html_fragment)[0];

  tbody.prepend(postNode);

  hideBlockedPosts();
  removeDuplicates();
  ensureFilterButtons();

  if (document.hidden && !isPostBlocked(post)) {
    unreadPosts++;

    document.title = `(${unreadPosts}) Galīga Ciba | Latest Posts)`;
  }
};

const loadTop = async () => {
  const response = await fetch('/?before=' + firstPostUrl());

  if (response.ok) {
    const html = await response.text();

    if (html.indexOf('<tr') === -1) return;

    const tbody = document.querySelector('body > #Content > table > tbody');
    tbody.insertAdjacentHTML('beforebegin', html);

    hideBlockedPosts();
    removeDuplicates();
    ensureFilterButtons();
  }
};

const firstPostUrl = () => document.querySelector('body > #Content > table > tbody > tr:first-child > td:first-child > a').getAttribute('href');

export const initCable = () => {
  const token = document.querySelector('meta[name="cable_token"]').getAttribute('content');
  const consumer = createConsumer('/cable?token=' + token);

  return consumer.subscriptions.create({ channel: 'LatestPostsChannel', room: 'all' }, {
    received: receivedCallback,

    initialized() {
    },

    connected() {
      loadTop();
    },

    disconnected() {
    },

    rejected() {
    },
  });
};

document.addEventListener('visibilitychange', (e) => {
  if (!document.hidden) {
    document.title = 'Galīga Ciba | Latest Posts';
    unreadPosts = 0;
  }
});

document.addEventListener('DOMContentLoaded', (e) => {
  initCable();
});
